export default "__VITE_ASSET__CGHQfGRx__"